import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TagIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tag"}/>
}
